// extracted by css-extract-rspack-plugin
var _1 = "TPCmXVhDXOAIyBwk";
export { _1 as "container" }
// extracted by css-extract-rspack-plugin
var _1 = "TPCmXVhDXOAIyBwk";
export { _1 as "container" }
